module.exports = __webpack_public_path__ + "img/menu-minus.e33482c1.svg";